import {h, Component} from 'preact'
import Spinner from "./Spinner";

export function AppLoading({message}) {
  return <div className={'app-loading'}>
    <h3>{message}</h3>
  </div>
}
